import React from 'react'
import GraphDiagram from '../../components/GraphDiagram'
import '../../styles/pages/settings.css'

/** Таб «Схема» внутри редактирования конфигурации. */
export default function SettingsConfigGraph() {
  return (
    <div className="settings-config-graph graph-page-diagram">
      <GraphDiagram defaultView="pipeline" singleView="pipeline" />
    </div>
  )
}
